export default __webpack_public_path__ + "images/ceb50f35935af88664d1a94da35d4b3b.svg";